import React, { useEffect, useContext, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';
import { AppSettings, externalAddress } from '../../config/app-settings.js';
import { Modal } from 'bootstrap';
import { Icon } from '@iconify/react';
import { Card, CardHeader, CardBody } from './../../components/card/card.jsx';
import Chart from 'chart.js/auto';
import Moment from 'moment';
import { externalFetch } from '../../config/externalFetch.js';
import { render } from 'sass';
import Select, { defaultTheme } from 'react-select';
import { getChartJsDefaultOptions } from './../../composables/chartOptions.js';
import '../../scss/pages/biblioteca.css';

function ListagemSetups() {
	const context = useContext(AppSettings);
	const [posMobileSidebarToggled, setPosMobileSidebarToggled] = useState(false);
	const [categoryType, setCategoryType] = useState('all');
	const [tableData, setTableData] = useState([]);
	const [orderData, setOrderData] = useState([]);
	const [orderHistoryData, setOrderHistoryData] = useState([]);
	const [modal, setModal] = useState();
	const [modalData, setModalData] = useState();
	const [modalQuantity, setModalQuantity] = useState();
	const [modalSelectedSize, setModalSelectedSize] = useState();
	const [modalSelectedAddon, setModalSelectedAddon] = useState([]);

	const [estrategiaData, setEstrategiaData] = useState([]);
	const [classeDeAtivosOptions, setClasseDeAtivosOptions] = useState([]);
	const [ativosOptions, setAtivosOptions] = useState([]);
	const [timeframesOptions, setTimeframesOptions] = useState([]);
	const [ladosOptions, setLadosOptions] = useState([]);
	const [prazosOptions, setPrazosOptions] = useState([]);
	const [sentidosOptions, setSentidosOptions] = useState([]);
	const [estilosOptions, setEstilosOptions] = useState([]);
	const [robosOptions, setRobosOptions] = useState([]);

	const [nomeFiltro, setNomeFiltro] = useState('');
	const [classesSelecionadas, setClassesSelecionadas] = useState([]);
	const [ativosSelecionados, setAtivosSelecionados] = useState([]);
	const [timeframesSelecionados, setTimeframesSelecionados] = useState([]);
	const [ladosSelecionados, setLadosSelecionados] = useState([]);
	const [prazosSelecionados, setPrazosSelecionados] = useState([]);
	const [sentidosSelecionados, setSentidosSelecionados] = useState([]);
	const [estilosSelecionados, setEstilosSelecionados] = useState([]);
	const [robosSelecionados, setRobosSelecionados] = useState([]);

	const [pageLoad, setPageLoad] = useState(1);
	const [lastIndex, setLastIndex] = useState(0);
	const [loading, setLoading] = useState(false);
	const [loadingInicial, setLoadingInicial] = useState(false);
	const [showFiltros, setShowFiltros] = useState(false);

/*
	var classeDeAtivosOptions = [
		{ value: 'Índices', label: 'Índices'},
		{ value: 'Ações', label: 'Ações' },
		{ value: 'Forex/Câmbio', label: 'Forex/Câmbio' },
		{ value: 'ETFs', label: 'ETFs' },
		{ value: 'FIIs', label: 'FIIs' },
		{ value: 'Renda fixa', label: 'Renda fixa' },
		{ value: 'Criptomoedas', label: 'Criptomoedas'}
	];*/

	var prevDay = Moment().add(-1, 'd').format('D MMM YYYY');
	var nextDay = Moment().add(0, 'd').format('D MMM YYYY');

	

	function renderChart(lista, nextPageLoad=1) {
		function newDate(days) {
			return Moment().add(days, 'd').format('D MMM');
		}

		function formatarData(dataMMDDYYYY) {
			const [mes, dia, ano] = dataMMDDYYYY.split("-");
			return `${dia}/${mes}/${ano}`;
		}
		
		// color & font variable
		var gray300Color = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300')).trim();
		var gray300RgbColor = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300-rgb')).trim();
		var indigoColor = (getComputedStyle(document.body).getPropertyValue('--bs-indigo')).trim();
		var bodyBg = (getComputedStyle(document.body).getPropertyValue('--bs-body-bg')).trim();
		var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();

		var color1 = 'rgba(40, 120, 212, 0.3)';
		var color2 = 'rgba(255, 169, 38, 0.98)';
		var color3 = 'rgba(255, 241, 68, 0.3)';
		//var color2 = 'rgb(250, 244, 234, 0.98)';
		//var color3 = 'rgba(240, 240, 233, 0.3)';
	

		//console.log('renderChart pageLoad '+nextPageLoad)

		const inicio = (nextPageLoad - 1) * 20 + 1;
		const fim = nextPageLoad * 20;
	
		lista.map((data, index) => {

			index = index + inicio -1
			//isBlack = data[i].
			//console.log('chart '+index);

			var chart2 = '';
			var chart2Container = document.getElementById('chart-'+index);
			if (chart2) {
				chart2.destroy();
			}

			var defaultColor = color1;
			var defaultBorderColor = themeColor;

			if (data.metricas.FR > 10)  {
				defaultColor = color3;
			    defaultBorderColor = color2;
			}

			/*
			if (index == 1)
				defaultColor = color2;
			else if (index == 2)
				defaultColor = color3;
			else if (index == 4)
				defaultColor = color3;
			*/

			if (chart2Container) {

				const values = data.grafico.map(item => item.y);
				const labels = data.grafico.map(item => formatarData(item.x));

				chart2Container.innerHTML = '<canvas id="chart'+index+'" className="w-100" height="290"></canvas>';
				chart2 = new Chart(document.getElementById('chart'+index).getContext('2d'), {
					type: 'line',
					
					data: {
						fill: true,
						//labels: [0, 20, 50, 100, 120, 180, 210, 220, 250, 280, 300, 315, 320, 380, 390, 400, 420, 425, 438, 20, 50, 100, 120, 180, 210, 220, 250, 280, 300, 315, 320, 380, 390, 400, 420, 425, 438],
						
						labels: labels,
						datasets: [{
							label: 'Lucro Acumulado',
							color: indigoColor,
							backgroundColor: defaultColor,
							borderColor: defaultBorderColor,
							borderWidth: 2,
							pointBackgroundColor: bodyBg,
							pointBorderWidth: 2,
							pointRadius: 2,
							pointHoverBackgroundColor: bodyBg,
							pointHoverBorderColor: themeColor,
							pointHoverRadius: 6,
							pointHoverBorderWidth: 2,
							fill: true,
							data: values
						}]
					},
					options: {
						maintainAspectRatio: false,
						plugins: {
							legend: {
							  display: false
							}
						},
						scales: {
							x: {
								grid: {
									//display: false  // 🔸 cor do grid vertical (eixo X)
									color: gray300RgbColor,
									lineWidth: 0.1
								},
								ticks: {
									color: '#FFFFFF' // 🔸 cor dos labels do eixo X
								}
							},
							y: {
								grid: {
									//display: false   // 🔸 cor do grid vertical (eixo X)
									color: gray300RgbColor,
									lineWidth: 0.1
								},
								ticks: {
									color: '#FFFFFF' // 🔹 cor dos labels do eixo Y
								}
							}
						}
					},
					
				});
			}

		})

		/*
		var chart2 = '';
		var chart2Container = document.getElementById('chart-2');
		if (chart2) {
			chart2.destroy();
		}

		if (chart2Container) {

			chart2Container.innerHTML = '<canvas id="chart2" className="w-100" height="190"></canvas>';
			chart2 = new Chart(document.getElementById('chart2').getContext('2d'), {
				type: 'line',
				
				data: {
					fill: true,
					labels: [0, 20, 50, 100, 120, 180, 210, 220, 250, 280, 300, 315, 320, 380, 390, 400, 420, 425, 438, 20, 50, 100, 120, 180, 210, 220, 250, 280, 300, 315, 320, 380, 390, 400, 420, 425, 438],
					datasets: [{
						color: themeColor,
						//backgroundColor: 'transparent',
						//borderColor: themeColor,
						borderWidth: 2,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 4,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						fill: true,
					
						data: [0, 20, 50, 100, 120, 180, 210, 220, 250, 280, 300, 315, 320, 380, 390, 400, 420, 425, 438, 20, 50, 100, 120, 180, 210, 220, 250, 280, 300, 315, 320, 380, 390, 400, 420, 620, 700]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}
		*/

	}
	
	var toggleMobileSidebar = (event) => {
		event.preventDefault();
		
		setPosMobileSidebarToggled(true);
	}
	
	var dismissMobileSidebar = (event) => {
		event.preventDefault();
		
		setPosMobileSidebarToggled(false);
	}
	
	var showType = (event, type) => {
		event.preventDefault();
		
		if (tableData && tableData.food) {
			for (var i = 0; i < tableData.food.length; i++) {
				if (tableData.food[i].type === type || type === 'all') {
					tableData.food[i].hide = false;
				} else {
					tableData.food[i].hide = true;
				}
			}
			
			setTableData(tableData);
			setCategoryType(type);
		}
	}
	
	var showPosItemModal = (event, food) => {
		event.preventDefault();
		
		if (food.available) {
			setModalData(food);
			setModalQuantity(1);
			setModalSelectedAddon([]);
			
			modal.show();
		}
	}
	
	var getOrderTotal = () => {
		return (orderData) ? orderData.length : 0;
	}
	
	var getOrderHistoryTotal = () => {
		return (orderHistoryData) ? orderHistoryData.length : 0;
	}
	
	var deductQty = (event, id) => {
		event.preventDefault();
		
		if (orderData) {
			const newData = orderData.map(obj => {
				if (obj.id === id) {
					var newQty = parseInt(obj.quantity) - 1;
					
					if (newQty < 1) {
						newQty = 1;
					}
					return {...obj, quantity: newQty};
				}
				
				return obj;
			});
			
			setOrderData(newData);
		}
	}
	
	var addQty = (event, id) => {
		event.preventDefault();
		
		if (orderData) {
			const newData = orderData.map(obj => {
				if (obj.id === id) {
					var newQty = parseInt(obj.quantity) + 1;
					return {...obj, quantity: newQty};
				}
				
				return obj;
			});
			
			setOrderData(newData);
		}
	}
	
	var getSubTotalPrice = () => {
		var value = 0;
		
		if (orderData) {
			for (var i = 0; i < orderData.length; i++) {
				value += parseFloat(orderData[i].price) * parseInt(orderData[i].quantity);
			}
		}
		return value.toFixed(2);
	}
	
	var getTaxesPrice = () => {
		var value = 0;
		
		if (orderData) {
			for (var i = 0; i < orderData.length; i++) {
				value += parseFloat(orderData[i].price) * parseInt(orderData[i].quantity) * .06;
			}
		}
		return value.toFixed(2);
	}
	
	var getTotalPrice = () =>  {
		var value = 0;
		
		if (orderData) {
			for (var i = 0; i < orderData.length; i++) {
				value += parseFloat(orderData[i].price) * parseInt(orderData[i].quantity);
				value += parseFloat(orderData[i].price) * parseInt(orderData[i].quantity) * .06;
			}
		}
		return value.toFixed(2);
	}
	
	var toggleConfirmation = (event, id, value) => {
		event.preventDefault();
		
		if (orderData) {
			const newData = orderData.map(obj => {
				if (obj.id === id) {
					return {...obj, confirmation: value};
				}
				return obj;
			});
			
			setOrderData(newData);
		}
	}
	
	var removeOrder = (event, id) => {
		event.preventDefault();
		
		if (orderData) {
			const newData = orderData.filter(function(order) { 
				return order.id !== id
			});
			
			setOrderData(newData);
		}
	}
	
	var addModalQty = (event) => {
		event.preventDefault();
		if (modalQuantity) {
			var newQty = parseInt(modalQuantity) + 1;
			
			setModalQuantity(newQty);
		}
	}
	
	var deductModalQty = (event) => {
		event.preventDefault();
		
		if (modalQuantity) {
			var newQty = parseInt(modalQuantity) - 1;
		
			if (newQty < 1) {
				newQty = 1;
			}
			setModalQuantity(newQty);
		}
	}
	
	var handleSizeChange = (event) => {
		var value = '';
		if (event.target.checked) {
			value = event.target.value;
		}
		
		setModalSelectedSize(value);
	}
	
	var handleAddonChange = (event) => {
		var elms = [].slice.call(document.querySelectorAll('input[name="addon"]'));
		var targetValue = [];
		
		elms.map(function(elm) {
			if (elm.checked) {
				targetValue.push(elm.value);
			}
			return true;
		});
		
		setModalSelectedAddon(targetValue);
	}
	
	var addToCart = (event) => {
		event.preventDefault();
		
		modal.hide();
		
		var options = [];
		if (modalSelectedSize) {
			var option = {
				"key": "size",
				"value": modalSelectedSize
			};
			options.push(option);
		}
		if (modalSelectedAddon) {
			for (var i = 0; i < modalSelectedAddon.length; i++) {
				var option2 = {
					"key": "addon",
					"value": modalSelectedAddon[i]
				};
				options.push(option2);
			}
		}
		
		setTimeout(() => {
			setOrderData([...orderData, {
				"id": (tableData.order.length + 1),
				"image": modalData.image,
				"title": modalData.title,
				"price": modalData.price,
				"quantity": modalQuantity,
				"options": options
			}]);
		}, 500);
	}

	function gerarOptions(lista) {
		return lista.map(item => ({
			value: item,
			label: item
		}));
	}
  
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentFullHeight(true);
		context.setAppContentClass('p-0');
		getChartJsDefaultOptions();
		
		setModal(new Modal(document.getElementById('modalPosItem')));

		//externalFetch('/api/biblioteca/listagem', 'GET', {}, (result) => this.loadListagem(result));

		setLoadingInicial(true);
		//setShowFiltros(true);

		fetch(externalAddress+'/api/biblioteca/listagem').then(res => res.json()).then((result) => { 
			setEstrategiaData(result.estrategias); 
			setLastIndex(result.lastIndex)
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoadingInicial(false);
				setShowFiltros(false);
			});
		});

		fetch(externalAddress+'/api/biblioteca/filtros').then(res => res.json()).then((result) => { 

			setClasseDeAtivosOptions(gerarOptions(result.filtros.classes));
			setAtivosOptions(gerarOptions(result.filtros.ativos));
			setTimeframesOptions(gerarOptions(result.filtros.timeframes));
			setLadosOptions(gerarOptions(result.filtros.lados));
			setPrazosOptions(gerarOptions(result.filtros.prazos));
			setSentidosOptions(gerarOptions(result.filtros.sentidos));
			setEstilosOptions(gerarOptions(result.filtros.estilos));
			setRobosOptions(gerarOptions(['SDK', 'Orbit']));
			
		});
		
		fetch('/assets/data/pos/customer-order.json').then(res => res.json()).then((result) => { 
			setTableData(result); 
			setOrderData(result.order); 
			setOrderHistoryData(result.history);
		});

		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentFullHeight(false);
			context.setAppContentClass('');
		}
		
		// eslint-disable-next-line
	}, []);

	var carregarMais = () => {
		
		let nextPageLoad = (pageLoad+1);

		setPageLoad(nextPageLoad);	
		filtrar(nextPageLoad, lastIndex);
	}

	var aplicarFiltro = () => {
		
		let nextPageLoad = 1;

		setPageLoad(nextPageLoad);	
		filtrar(nextPageLoad, 0);
	}

	var filtrarTendencia = () => {

		setLoading(true);
		setShowFiltros(false);
		setPageLoad(1);	

		setSentidosSelecionados([{value: 'Tendência', label: 'Tendência'}]);
		setAtivosSelecionados([]);

		const params = new URLSearchParams();
		params.append('sentidos', 'Tendência');
		params.append('lastIndex', 0)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			setLastIndex(result.lastIndex)
			setEstrategiaData(result.estrategias); 
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoading(false);
			});

			if (result.estrategias.length == 0)
				setShowFiltros(true);
		});

	}

	
	var filtrarContratendencia = () => {

		setLoading(true);
		setShowFiltros(false);
		setPageLoad(1);	

		setSentidosSelecionados([{value: 'Contratendência', label: 'Contratendência'}]);
		setAtivosSelecionados([]);

		const params = new URLSearchParams();
		params.append('sentidos', 'Contratendência');
		params.append('lastIndex', 0)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			setLastIndex(result.lastIndex)
			setEstrategiaData(result.estrategias); 
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoading(false);
			});

			if (result.estrategias.length == 0)
				setShowFiltros(true);
		});

	}

	var filtrarRRPositivo = () => {

		setLoading(true);
		setShowFiltros(false);
		setPageLoad(1);	

		//setSentidosSelecionados([{value: 'Contratendência', label: 'Contratendência'}]);
		setAtivosSelecionados([]);

		const params = new URLSearchParams();
		params.append('riscoretorno', 'positivo');
		params.append('lastIndex', 0)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			setLastIndex(result.lastIndex)
			setEstrategiaData(result.estrategias); 
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoading(false);
			});

			if (result.estrategias.length == 0)
				setShowFiltros(true);
		});

	}

	var filtrarRRNegativo = () => {

		setLoading(true);
		setShowFiltros(false);
		setPageLoad(1);	

		setAtivosSelecionados([]);

		const params = new URLSearchParams();
		params.append('riscoretorno', 'negativo');
		params.append('lastIndex', 0)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			setLastIndex(result.lastIndex)
			setEstrategiaData(result.estrategias); 
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoading(false);
			});

			if (result.estrategias.length == 0)
				setShowFiltros(true);
		});

	}

	var filtrarIndices = () => {

		setLoading(true);
		setShowFiltros(false);
		setPageLoad(1);	

		setSentidosSelecionados([]);
		setAtivosSelecionados([{value: 'Índices', label: 'Índices'}]);

		const params = new URLSearchParams();
		params.append('classes', 'Índices');
		params.append('lastIndex', 0)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			setLastIndex(result.lastIndex)
			setEstrategiaData(result.estrategias); 
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoading(false);
			});

			if (result.estrategias.length == 0)
				setShowFiltros(true);
		});

	}

	var filtrarAcoes = () => {

		setLoading(true);
		setShowFiltros(false);
		setPageLoad(1);	

		setSentidosSelecionados([]);
		setAtivosSelecionados([{value: 'Ações', label: 'Ações'}]);

		const params = new URLSearchParams();
		params.append('classes', 'Ações');
		params.append('lastIndex', 0)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			setLastIndex(result.lastIndex)
			setEstrategiaData(result.estrategias); 
			requestAnimationFrame(() => {
				renderChart(result.estrategias);
				setLoading(false);
			});

			if (result.estrategias.length == 0)
				setShowFiltros(true);
		});

	}

	var filtrar = (nextPageLoad, newLastIndex) => {

		//console.log('filtrar')

		setLoading(true);

		const params = new URLSearchParams();

		classesSelecionadas.forEach(item => {
			params.append('classes', item.value);
		});

		ativosSelecionados.forEach(item => {
			params.append('ativos', item.value);
		});

		timeframesSelecionados.forEach(item => {
			params.append('timeframes', item.value);
		});

		ladosSelecionados.forEach(item => {
			params.append('lados', item.value);
		});

		prazosSelecionados.forEach(item => {
			params.append('prazos', item.value);
		});

		//console.log('sentidosSelecionados');
		//console.log(sentidosSelecionados);

		sentidosSelecionados.forEach(item => {
			params.append('sentidos', item.value);
		});

		estilosSelecionados.forEach(item => {
			params.append('estilos', item.value);
		});

		robosSelecionados.forEach(item => {
			params.append('robos', item.value);
		});

		params.append('nome', nomeFiltro)
		params.append('lastIndex', newLastIndex)

		fetch(`${externalAddress}/api/biblioteca/listagem?${params.toString()}`, { cache: 'no-store' })
		.then(res => res.json())
		.then((result) => { 
			//console.log(result.estrategias)
			//setEstrategiaData(result.estrategias); 
			//estrategiaData.push(result)
			setLastIndex(result.lastIndex)
			if (nextPageLoad > 1)
				setEstrategiaData(prev => [...prev, ...result.estrategias]); 
			else
				setEstrategiaData(result.estrategias); 
			/*setEstrategiaData(prev => {
				console.log(prev);  
				return [...prev.estrategias, ...result];
			  });
			  */
			requestAnimationFrame(() => {
				renderChart(result.estrategias, nextPageLoad);
				setLoading(false);
			});
		});

	};

	var exibirFiltro = () => {
		
		if (showFiltros)
			setShowFiltros(false);
		else
			setShowFiltros(true);
	}
	
	return (
		<>

			
			<div className={'pos pos-with-menu pos-with-sidebar' + ((posMobileSidebarToggled) ? 'pos-mobile-sidebar-toggled' : '')} id="pos">
				<div className="pos-container">
					<div className="pos-menu" style={{paddingTop: '2.6rem'}}>
						<div className="logo">
							<Link to="/">
								<div className="logo-img"><Icon icon="material-symbols-light:public" className="fs-50px text-white" /></div>
								<div className="logo-text">SETUPS</div>
							</Link>
						</div>
						<div className="nav-container">
							<PerfectScrollbar className="h-100">
								<ul className="nav nav-tabs">
									<li className="nav-item">
										<a className={'nav-link'} href="#/" onClick={filtrarTendencia}>
											<Icon icon="material-symbols-light:earthquake" className="nav-icon" /> Tendência
										</a>
									</li>
									<li className="nav-item">
										<a className={'nav-link'} href="#/" onClick={filtrarContratendencia}>
											<Icon icon="material-symbols-light:rebase" className="nav-icon" /> Contratendência
										</a>
									</li>
									<li className="nav-item">
										<a className={'nav-link'} href="#/" onClick={filtrarRRPositivo}>
											<Icon icon="material-symbols-light:north" className="nav-icon" /> RxR Positivo
										</a>
									</li>
									<li className="nav-item">
										<a className={'nav-link'} href="#/" onClick={filtrarRRNegativo}>
											<Icon icon="material-symbols-light:south" className="nav-icon" /> RxR Negativo
										</a>
									</li>
									<li className="nav-item">
										<a className={'nav-link'} href="#/" onClick={filtrarIndices}>
											<Icon icon="material-symbols-light:upgrade" className="nav-icon" /> Índices
										</a>
									</li>
									<li className="nav-item" onClick={filtrarAcoes}>
										<a className={'nav-link'} href="#/">
											<Icon icon="material-symbols-light:savings" className="nav-icon" /> Ações
										</a>
									</li>
								</ul>
								{/*
								<ul className="nav nav-tabs">
									<li className="nav-item">
										<a className={'nav-link' + ((category.type === categoryType) ? ' active' : '')} onClick={(event) => showType(event, category.type)} href="#/">
											<Icon icon={category.icon} className="nav-icon" /> {category.text}
										</a>
									</li>
								</ul>
								*/}
							</PerfectScrollbar>
						</div>
					</div>

					<div className="pos-header">
						<div className="logo">
							<Link to="/">
								<div className="logo-img"><Icon icon="material-symbols-light:public" /></div>
								
								<div className="logo-text">BIBLIOTECA DE SETUPS</div>
							</Link>
						</div>
						<div className="time" id="time"></div>
						<div className="nav">
								
							<div className="" style={{marginRight: '10px'}}>
								<a href="https://www.youtube.com/watch?v=KjR3Z72bz78" data-lity data-sveltekit-reload="">
									<button type="button" className="btn btn-outline-theme">COMO FUNCIONA?</button>
								</a>
								{/*}
								<Link to="/oferta" target='_blank' data-bs-toggle="tooltip" data-bs-placement="bottom" className="nav-link active">
									<div className="nav-icon">
									<button type="button" className="btn btn-theme">OFERTA DE LANÇAMENTO</button>
									</div>
								</Link>
								*/}
							</div>
							<div className="">
								<Link to="#/" onClick={exibirFiltro} data-bs-toggle="tooltip" data-bs-placement="bottom" className="nav-link active d-none d-md-inline">
									<div className="nav-icon">
										<button type="button" className="btn btn-theme">PERSONALIZAR BUSCA</button>
									</div>
								</Link>
							</div>
						</div>
					</div>


					<div className="main-row row g-3"  style={{marginRight: '0px', paddingTop: '2.6rem'}}>

					{estrategiaData.length > 0 ? (estrategiaData.map((estrategia, index) => (
						<div className="col-sm-6 col-xl-4" >
							<Card>
								<CardHeader className="d-flex">
									{estrategia.nome} | {estrategia.robo} <span className="ms-auto badge destaque-black ">{estrategia.metricas.FR > 10 ? 'BLACK' : ''}</span>
								</CardHeader>
								<CardBody>
									<div className="row g-3">
										<div className="col-4">
											<div className="d-flex align-items-center">
											<div className="fs-32px text-theme d-flex w-40px">
												<Icon icon="material-symbols-light:touch-app-outline" style={{color: estrategia.metricas.FR > 10 ? '#fff144' : ''}} />
											</div>
											<div className="flex-1">
												<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
												Ativo
												</div>
												<div className="h6 mb-0 fw-base">{estrategia.ativo}</div>
											</div>
											</div>
										</div>
										<div className="col-4">
											<div className="d-flex align-items-center">
											<div className="fs-32px text-theme d-flex w-40px">
												<Icon icon="material-symbols-light:group-outline" style={{color: estrategia.metricas.FR > 10 ? '#fff144' : ''}} />
											</div>
											<div className="flex-1">
												<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
												Sentido
												</div>
												<div className="h6 mb-0 fw-base">{estrategia.sentido}</div>
											</div>
											</div>
										</div>

										<div className="col-4">
											<div className="d-flex align-items-center">
											<div className="fs-32px text-theme d-flex w-40px">
												<Icon icon="material-symbols-light:store-outline" style={{color: estrategia.metricas.FR > 10 ? '#fff144' : ''}} />
											</div>
											<div className="flex-1">
												<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
												Payoff
												</div>
												<div className="h6 mb-0 fw-base">{estrategia.metricas.payoff}</div>
											</div>
											</div>
										</div>

										<div className="col-4">
											<div className="d-flex align-items-center">
											<div className="fs-32px text-theme d-flex w-40px">
												
												<Icon icon="material-symbols-light:bar-chart-4-bars" style={{color: estrategia.metricas.FR > 10 ? '#fff144' : ''}} />
											</div>
											<div className="flex-1">
												<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
												Lucro
												</div>
												<div className="h6 mb-0 fw-base">{estrategia.metricas.lucro}</div>
											</div>
											</div>
										</div>

										<div className="col-4">
											<div className="d-flex align-items-center">
											<div className="fs-32px text-theme d-flex w-40px">
												<Icon icon="material-symbols-light:approval-delegation-outline" style={{color: estrategia.metricas.FR > 10 ? '#fff144' : ''}} />
											</div>
											<div className="flex-1">
												<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
												Drawdown Máximo
												</div>
												<div className="h6 mb-0 fw-base">{estrategia.metricas.floating.floatingDD}</div>
											</div>
											</div>
										</div>

										<div className="col-4">
											<div className="d-flex align-items-center">
											<div className="fs-32px text-theme d-flex w-40px">
												<Icon icon="material-symbols-light:app-badging-outline" style={{color: estrategia.metricas.FR > 10 ? '#fff144' : ''}} />
											</div>
											<div className="flex-1">
												<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
												Fator de Recuperação
												</div>
												<div className="h6 mb-0 fw-base">{estrategia.metricas.FR}</div>
											</div>
											</div>
										</div>

									</div>
									<hr />
									<div className="fs-10px fw-semibold mb-3">Curva de Capital</div>
									<div className="chart mb-2" style={{height: '290px'}}>
										<div id={"chart-"+index}></div>
									</div>
									<div className="d-flex">
										
										<span className="w-10px"></span>
										<a href={'/setup/'+estrategia.uuid} className="btn btn-sm btn-secondary d-block flex-1">DETALHES <i className="fa fa-chart-line"></i></a>
									</div>
									
								</CardBody>
							</Card>
							
						</div>
					))) : (
						<>
						{!loadingInicial  ?
							<div className="row g-3">
							<Card>
								<CardBody>
									Nenhum setup encontrado para este filtro
								</CardBody>
							</Card>
							</div>
						:
						''}
						</>
					)}

					<div>
						<div className="p-0">

							{loadingInicial  ?
									<div className="row g-4 g-lg-4">
										<div className="col-sm-6 col-xl-4">
											<div className="ratio" style={{ "--bs-aspect-ratio": "68.46%" }}>
												<div><div className="shimmer-loader h-100"></div></div>
											</div>
										</div>
										<div className="col-sm-6 col-xl-4">
											<div className="ratio" style={{ "--bs-aspect-ratio": "68.46%" }}>
												<div><div className="shimmer-loader h-100"></div></div>
											</div>
										</div>	
										<div className="col-sm-6 col-xl-4">
											<div className="ratio" style={{ "--bs-aspect-ratio": "68.46%" }}>
												<div><div className="shimmer-loader h-100"></div></div>
											</div>
										</div>
										
									</div>
								:
									<>
									
									</>
							}

							{!loading && !loadingInicial ?
								<a href="#/" onClick={carregarMais} className="list-group-item list-group-action text-center px-3 py-2">
									<button type="button" className="btn btn-outline-theme ">Carregar Mais</button>
								</a>
							:
								<div class="d-flex justify-content-center" style={{marginTop: '8px', marginBottom: '8px'}}>
									<div class="spinner-grow spinner-grow-sm text-primary" role="status">
									</div>
									<span className="fw-semibold mt-20"> &nbsp; Processando...</span>
								</div>
							}
						</div>
					</div>
			
					</div>

					{showFiltros ?

					<div className="pos-sidebar" id="pos-sidebar" style={{paddingTop: '2.6rem'}}>
						<div className="h-100 d-flex flex-column p-0">
							<div className="pos-sidebar-header mb-2px">
								<div className="back-btn">
									<button type="button" onClick={dismissMobileSidebar} className="btn">
										<i className="fa fa-chevron-left"></i>
									</button>
								</div>
								<div className="icon"><Icon icon="material-symbols-light:table-restaurant-sharp" /></div>
								<div className="title">Filtros</div>
							</div>
					
					
							<PerfectScrollbar className="pos-sidebar-body tab-content h-100">
								<div className="tab-pane fade h-100 show active" id="newOrderTab">

									<div className="pos-order">
										<div className="pos-order-product">
											<div className="col-xl-12">
												<div className="mb-3">
													<label className="form-label">Nome da Estratégia</label>
													<input className="form-control" onChange={(e) => setNomeFiltro(e.target.value)} type="text" placeholder="Nome..."/>
												</div>

												<div className="mb-3">
													<label className="form-label">Classe de Ativo</label>
													<Select isMulti name="classes" onChange={(selected) => setClassesSelecionadas(selected)} options={classeDeAtivosOptions} classNamePrefix="react-select" />
												</div>
												<div className="mb-3">
													<label className="form-label">Ativo</label>
													<Select isMulti name="ativos" value={ativosSelecionados} onChange={(selected) => setAtivosSelecionados(selected)} options={ativosOptions} classNamePrefix="react-select" />
												</div>
												<div className="mb-3">
													<label className="form-label">Timeframe</label>
													<Select isMulti name="timeframes" onChange={(selected) => setTimeframesSelecionados(selected)} options={timeframesOptions} classNamePrefix="react-select" />
												</div>
												<div className="mb-3">
													<label className="form-label">Lado</label>
													<Select isMulti name="lados" onChange={(selected) => setLadosSelecionados(selected)} options={ladosOptions} classNamePrefix="react-select" />
												</div>

												<div className="mb-3">
													<label className="form-label">Prazo Operacional</label>
													<Select isMulti name="prazos" onChange={(selected) => setPrazosSelecionados(selected)} options={prazosOptions} classNamePrefix="react-select" />
												</div>

												<div className="mb-3">
													<label className="form-label">Sentido</label>
													<Select isMulti name="sentidos" value={sentidosSelecionados} onChange={(selected) => setSentidosSelecionados(selected)} options={sentidosOptions} classNamePrefix="react-select" />
												</div>

												<div className="mb-3">
													<label className="form-label">Robô</label>
													<Select isMulti name="robos" value={robosSelecionados} onChange={(selected) => setRobosSelecionados(selected)} options={robosOptions} classNamePrefix="react-select" />
												</div>

												
											</div>
										</div>
									</div>

									
								</div>
						
								<div className="tab-pane fade h-100" id="orderHistoryTab">
									<div className="h-100 d-flex align-items-center justify-content-center text-center">
										<div>
											<div className="mb-3 mt-n5">
												<svg width="6em" height="6em" viewBox="0 0 16 16" className="text-gray-300" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
													<path fillRule="evenodd" d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"/>
													<path d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"/>
												</svg>
											</div>
											<h5>No order history found</h5>
										</div>
									</div>
								</div>
							</PerfectScrollbar>
							
							<div className="pos-sidebar-footer">
								
								<div className="mt-3">
									<div className="btn-group d-flex">
										
										
										<a href="#/" className="btn btn-white btn-sm flex-fill d-flex flex-column align-items-center justify-content-center">
											{!loading ?
												<>
													<Icon  onClick={aplicarFiltro}  icon="material-symbols-light:send" className="fs-24px d-flex justify-content-center" />
													<span  onClick={aplicarFiltro}  className="fw-semibold">Aplicar</span>
												</>
												:
												<>
													<div className="spinner-grow spinner-grow-sm text-primary"></div>
													<span className="fw-semibold">Processando...</span>
												</>
											}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>

					:

						<></>
					}
			
					{/*
					<div className="pos-content">
						<PerfectScrollbar className="pos-content-container h-100">
							<div className="row g-3">
								{tableData && tableData.food ? (tableData.food.map((food, index) => (
									<div className={'col-xl-3 col-md-4 col-6'+ ((food.hide) ? ' d-none' : '')} key={index}>
										<a href="#/" className={'pos-product'+ ((!food.available) ? ' not-available': '')} onClick={(event) => showPosItemModal(event, food)}>
											<div className="img" style={{backgroundImage: 'url('+ food.image +')'}}></div>
											<div className="info">
												<div className="title">{food.price}</div>
												<div className="desc">{food.description}</div>
												<div className="price">${food.price}</div>
											</div>
											{!food.available && (<div className="not-available-text"><div>Not Available</div></div>)}
										</a>
									</div>
								))) : (
									<div className="col-12">
										No records found
									</div>
								)}
							</div>
						</PerfectScrollbar>
					</div>
					*/}
				</div>
			</div>
	
			<div className="modal modal-pos fade" id="modalPosItem">
				<div className="modal-dialog modal-lg">
					<div className="modal-content border-0">
						{modalData && (
							<>
								<button data-bs-dismiss="modal" className="btn-close position-absolute top-0 end-0 m-4">&nbsp;</button>
								<div className="modal-pos-product">
									<div className="modal-pos-product-img">
										<div className="img" style={{backgroundImage: 'url('+ modalData.image +')'}}></div>
									</div>
									<div className="modal-pos-product-info">
										<div className="fs-4 fw-semibold">{ modalData.title }</div>
										<div className="text-body text-opacity-50 mb-2">
											{ modalData.description }
										</div>
										<div className="fs-3 fw-bold mb-3">${ modalData.price }</div>
										<div className="d-flex mb-3">
											<button className="btn btn-secondary" onClick={(event) => deductModalQty(event)}><i className="fa fa-minus"></i></button>
											<input type="text" value={modalQuantity} readOnly className="form-control w-50px fw-bold mx-2 bg-white bg-opacity-25 border-0 text-center" />
											<button className="btn btn-secondary" onClick={(event) => addModalQty(event)}><i className="fa fa-plus"></i></button>
										</div>
										<hr className="opacity-1" />
										{modalData && modalData.options && modalData.options.size && (
											<div className="mb-2">
												<div className="fw-bold">Size:</div>
												<div className="option-list">
													{modalData.options.size.map((size, index) => (
														<div className="option" key={index}>
															<input type="radio" id={'size' + index} name="size" className="option-input" defaultValue={size.text} onChange={(event) => handleSizeChange(event)} defaultChecked={((index === 0) ? true : false)} />
															<label className="option-label" htmlFor={'size' + index}>
																<span className="option-text">{size.text}</span>
																<span className="option-price">+{size.price}</span>
															</label>
														</div>
													))}
												</div>
											</div>
										)}
										{modalData && modalData.options && modalData.options.addon && (
											<div className="mb-2">
												<div className="fw-bold">Add On:</div>
												<div className="option-list">
													{modalData.options.addon.map((addon, index) => (
														<div className="option" key={index}>
															<input type="checkbox" name="addon" className="option-input" onChange={(event) => handleAddonChange(event)} value={addon.text} id={'addon'+ index} />
															<label className="option-label" htmlFor={'addon'+ index}>
																<span className="option-text">{addon.text}</span>
																<span className="option-price">+{addon.price}</span>
															</label>
														</div>
													))}
												</div>
											</div>
										)}
										<hr className="opacity-1" />
										<div className="row">
											<div className="col-4">
												<button className="btn btn-default fw-semibold mb-0 d-block py-3 w-100" data-bs-dismiss="modal">Cancel</button>
											</div>
											<div className="col-8">
												<button className="btn btn-theme fw-semibold d-flex justify-content-center align-items-center py-3 m-0 w-100" onClick={(event) => addToCart(event)}>Add to cart <i className="bi bi-plus fa-2x ms-2 my-n3"></i></button>
											</div>
										</div>
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default ListagemSetups;